export default __webpack_public_path__ + "static/media/clouds-left-large-desktop.c712f476.png";